const initialState = () => ({
  requests: [],
})

const state = initialState

const getters = {
  requests: state => state.requests
}

const mutations = {
  setDataRequests: (state, requests) => {
    state.requests = requests
  }
}

const actions = {
  async setEmailStatus ({ dispatch }, { optType, status }) {
    const data = {
      method: 'email_status',
      data: {
        type: optType,
        status
      }
    }
    try {
      return dispatch('makecall', data)
    } catch (e) {
      throw e
    }
  },
  async accessRecords ({ dispatch }) {
    try {
      const data = {
        method: 'gdpr_records',
      }
      return dispatch('makecall', data)
    } catch (e) {
      throw e
    }
  },
  async profileRemove ({ dispatch }) {
    try {
      const data = {
        method: 'gdpr_remove_profile',
      }
      return dispatch('makecall', data)
    } catch (e) {
      throw e
    }
  },
  async gdprDataRequests ({ commit, dispatch }) {
    const data = {
      method: 'gdpr_datarequests'
    }

    const { requests } = await dispatch('makecall', data)

    commit('setDataRequests', requests)
  },
  async gdprDataRequestsDownload ({ dispatch }, id) {
    const data = {
      method: 'gdpr_datarequests_download',
      data: {
        id
      }
    }

    return dispatch('makecall', data)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
